var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-icon',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],staticClass:"gl-text-gray-500",attrs:{"name":"lock","title":_vm.$options.i18n.privateProjectTooltip}})
}
var staticRenderFns = []

export { render, staticRenderFns }